import Datetime from 'utils/datetime/datetime'
import { Event } from './BarCalendar.types'

export const FILLER_EVENT_ID = 'filler'

/**
 * The events of one calendar row that overlap the visible period, cut to it, with a filler event in
 * each gap before an event so the bars sit at their times.
 */
export function getVisibleEvents(events: Event[], visibleStartTime: ISODateTime, visibleEndTime: ISODateTime): Event[] {
  const filteredEvents = events.filter((event) => {
    if (!event.startTime || !Datetime.isBeforeOrEqual(event.startTime, visibleEndTime)) {
      return false
    }

    if (event.endTime && !Datetime.isAfterOrEqual(event.endTime, visibleStartTime)) {
      return false
    }

    return true
  })

  const result: Event[] = []

  let previousEndTime = visibleStartTime
  for (const event of filteredEvents) {
    if (!event.startTime) {
      continue
    }

    let eventStartTime = event.startTime
    let eventEndTime = event.endTime

    if (Datetime.isBefore(previousEndTime, eventStartTime)) {
      result.push({
        id: FILLER_EVENT_ID,
        type: event.type,
        startTime: previousEndTime,
        endTime: eventStartTime,
        categoryId: event.categoryId,
        color: 'transparent',
        name: 'FILLER',
        // getNrOfHoursBetween(00:00, 00:00) = 1, so we need to subtract 1.
        hours: Datetime.getNrOfHoursBetween(eventStartTime, previousEndTime) - 1,
      })
    }

    if (eventEndTime == null || Datetime.isAfter(eventEndTime, visibleEndTime)) {
      eventEndTime = visibleEndTime
      event.isTurnicatedEnd = true
    }
    if (Datetime.isAfter(visibleStartTime, eventStartTime)) {
      eventStartTime = visibleStartTime
      event.isTurnicatedStart = true
    }

    event.hours = Datetime.getNrOfHoursBetween(eventEndTime, eventStartTime)
    result.push(event)
    previousEndTime = Datetime.addHours(eventEndTime, 1)
  }

  return result
}
